import { useUser } from '../contexts/UserContext';

export const useUserData = () => {
  const { user, loading, error, isAuthenticated } = useUser();

  const getUserDisplayName = () => {
    return user?.displayName || 'Unknown User';
  };

  const getUserPicture = () => {
    return user?.picture || null;
  };

  const getUserId = () => {
    return user?.userId || null;
  };

  const getUserStatusMessage = () => {
    return user?.statusMessage || '';
  };

  const isUserAvailable = () => {
    return isAuthenticated && !loading && !error;
  };

  return {
    // User data
    user,
    displayName: getUserDisplayName(),
    picture: getUserPicture(),
    userId: getUserId(),
    statusMessage: getUserStatusMessage(),
    
    // Status
    loading,
    error,
    isAuthenticated,
    isUserAvailable: isUserAvailable(),
    
    // Helper functions
    getUserDisplayName,
    getUserPicture,
    getUserId,
    getUserStatusMessage,
    isUserAvailable
  };
}; 